<template>
  <div>
    <common-dialog
      ref="dialog"
      :data="data"
      width="1200px"
      title="分箱列表"
      @edit-opened="opened"
      id-key="UserId"
      @close-saved="$emit('close-saved')"
      @closed="closeDialog"
      :confirm-on-close-change="false"
    >
      <el-row class="border">
        <el-form>
          <el-row>
            <el-col :span="5">
              <el-form-item label="工单编号" prop="SourceNo">
                <div class="detail-span">{{ data.SourceNo }}</div>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="存货名称" prop="ProductName">
                <div class="detail-span">{{ data.ProductName }}</div>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="批号" prop="BatchNumber">
                <div class="detail-span">{{ data.BatchNumber }}</div>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="存货条码" prop="Barcode">
                <div class="detail-span">{{ data.Barcode }}</div>
              </el-form-item>
            </el-col>
          </el-row><el-row>
            <el-col :span="5">
              <el-form-item label="数量" prop="Quantity">
                <div class="detail-span">{{ data.Quantity }}</div>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="单位" prop="UnitName">
                <div class="detail-span">{{ data.UnitName }}</div>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="数量2" prop="Quantity2">
                <div class="detail-span">{{ data.Quantity2 }}</div>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="单位2" prop="UnitName2">
                <div class="detail-span">{{ data.UnitName2 }}</div>
              </el-form-item>
            </el-col>
          </el-row></el-form
        >
      </el-row>
      <div class="box-header"><el-button type="success" @click="addGoods">添加</el-button> <el-button type="danger" @click="delGoods">删除</el-button></div>

      <el-table :data="tableData" border @selection-change="onSelectGoods">
        <el-table-column type="selection" width="35" />
        <el-table-column label="装箱规格" prop="PackingSpeciId" align="left" min-width="100">
          <template slot-scope="{ row }">
            <el-select v-model="row.PackingSpeciId" @change="changeSpeci($event, row)">
              <el-option v-for="item in packingspeciList" :key="item.PackingSpeciId" :label="item.SpeciName" :value="item.PackingSpeciId" :disabled="item.Status == 0"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="每件数" prop="PackingNumber" align="left" min-width="100"></el-table-column>
        <el-table-column label="件数" prop="PackingQuantity" align="left" min-width="100">
          <template slot-scope="{ row, $index }">
            <el-input type="text" @change="changePackingQuantity($event, row, $index)" v-model="row.PackingQuantity"></el-input>
          </template>
        </el-table-column>
        <el-table-column align="left" label="计量单位" min-width="120px">
          <template slot-scope="{ row }">
            <span>{{ row.UnitName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="数量" prop="Quantity" align="right" min-width="100">
          <template slot-scope="{ row, $index }">
            <el-input type="text" @change="changeQuantity($event, row, $index)" :disabled="!row.isEdit" v-model="row.Quantity">
              <el-button type="primary" icon="el-icon-edit" slot="append" v-if="row.PackingQuantity == 1" @click="isChange(row)"></el-button
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column align="left" label="计量单位2" min-width="120px">
          <template slot-scope="{ row }">
            <span>{{ row.UnitName2 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="数量2" prop="Quantity2" align="right" min-width="100"> </el-table-column>
      </el-table>
      <div slot="footer">
        <el-button type="primary" @click="saved">保存</el-button>
        <el-button @click="closeDialog">关 闭</el-button>
      </div>
    </common-dialog>
  </div>
</template>  
<script>
import editDialogMixin from '@/mixins/editDialog'
import commonDialog from '@/components/common/dialog'
import optionMixins from '@/mixins/option'

export default {
  mixins: [editDialogMixin, optionMixins],
  components: {
    commonDialog
  },
  props: {
    packingspeciList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      data: {},
      tableData: [],
      selectGoods: []
    }
  },
  methods: {
    isChange(row) {
      row.isEdit = !row.isEdit
    },
    changeQuantity(val, row,index) {
      row.isEdit = !row.isEdit
      if (row.PackingQuantity == 1) {
        row.RealPackingNumber = val
        if (row.HasGrammage == true) {
          row.Quantity2 = val * row.Rate
        }
        if (this.tableData.length > 0) {
          var sum = 0
          var csum=this.data.Quantity;
          this.tableData.forEach(x => {
            sum += Number(x.Quantity)
            csum-=Number(x.Quantity)
          })
          row.Quantity=Number(row.Quantity)+csum;
           if (row.HasGrammage == true) {
              row.Quantity2 = this.getQuantity(row.Quantity * row.Rate)
            }
          this.tableData[index]=row;
          console.log(sum,this.data.Quantity,"ss");
          if (sum > this.data.Quantity) {
            this.$message.warning('数量不能超过分箱前总数量')
            return
          }
        }
      } else {
        if (row.PackingNumber != row.RealPackingNumber) {
          this.$message.warning('aa')
          return
        } else {
          if (row.Units.length > 0) {
            if (row.IsMain) {
              if (row.HasGrammage == true) {
                row.Quantity2 = this.getQuantity(row.Quantity * row.Rate)
              } else {
                row.Quantity2 = this.getQuantity(row.Quantity / row.Rate)
              }
            } else {
              if (row.HasGrammage == true) {
                row.Quantity2 = this.getQuantity(row.Quantity / row.Rate)
              } else {
                row.Quantity2 = this.getQuantity(row.Quantity * row.Rate)
              }
            }
          }

          if (row.PackingSpeciId > 0) {
            if (row.PackingNumber > 0) {
              row.PackingQuantity = parseInt(row.Quantity / row.PackingNumber)
            }
          }
        }
      }
    },
    changePackingQuantity(val, row) {
      if (row.PackingNumber > 0) {
        if (row.PackingNumber != row.RealPackingNumber) {
          if (this.tableData.some(x => x.PackingSpeciId == row.PackingSpeciId).length > 1) {
            row.PackingNumber = item.PackingNumber
            row.RealPackingNumber = item.PackingNumber
            this.$message.warning('记录存在相同的装箱规格，无需重复添加')
            return
          }
        }
        if (val) {
          row.Quantity = parseInt(val * row.PackingNumber)
          if (row.Quantity > this.data.Quantity) {
            row.PackingQuantity = parseInt(this.data.Quantity / row.PackingNumber)
            row.Quantity = parseInt(row.PackingQuantity * row.PackingNumber)
            if (row.HasGrammage == true) {
              row.Quantity2 = this.getQuantity(row.Quantity * row.Rate)
            }
            this.$message.warning('数量不能超过分箱前总数量')
            return
          }

          if (row.HasGrammage == true) {
            row.Quantity2 = this.getQuantity(row.Quantity * row.Rate)
          }
        }
      }
      if (this.tableData.length > 0) {
        var sum = 0
        this.tableData.forEach(x => {
          sum += x.Quantity
        })
        if (sum > this.data.Quantity) {
          this.$message.warning('数量不能超过分箱前总数量')
          return
        }
      }
    },
    changeSpeci(val, row) {
      let item = this.packingspeciList.filter(item => {
        return item.PackingSpeciId === val
      })[0]
      console.log(item, 'changeSpeci')
      if (item) {
        row.PackingNumber = item.PackingNumber
        row.RealPackingNumber = item.PackingNumber
        if (row.Quantity) {
          row.PackingQuantity = parseInt(row.Quantity / row.PackingNumber)
        }
      }
    },
    opened(row) {
      this.data = row
      console.log('row', row, this.packingspeciList)
      this.callOptionApi()
    },
    addGoods() {
      var item = JSON.parse(JSON.stringify(this.data))
      item.Quantity = null
      item.Quantity2 = null
      item.groupIndex = item.index
      item.isEdit = false
      console.log(item, 'addgoods')
      this.tableData.push(item)
      this.tableData.forEach((i, d) => {
        i.Id = d
      })
    },
    delGoods() {
      if (this.selectGoods.length == 0) {
        this.$message.warning('请选择要删除的数据')
        return
      }
      this.selectGoods.forEach(x => {
        var index = this.tableData.findIndex(w => w == x)
        this.tableData.splice(index, 1)
      })
      //清空选中的数据
      this.selectGoods = []
      //对序号进行重新排序
      this.tableData.forEach((x, i) => (x.Id = i))
    },
    onSelectGoods(row) {
      this.selectGoods = row
    },
    saved() {
      if (this.tableData.length == 0) {
        this.$message.warning('请添加分箱信息')
        return
      }
      for (let index = 0; index < this.tableData.length; index++) {
        const item = this.tableData[index]
        if (item.PackingSpeciId == null || item.PackingSpeciId == null) {
          this.$message({ type: 'warning', message: '请选择装箱规格' })
          return
        }
        if (item.PackingQuantity == null || item.PackingQuantity == 0) {
          this.$message({ type: 'warning', message: '请填写件数' })
          return
        }

        if (item.Quantity == null || item.Quantity == 0) {
          this.$message({ type: 'warning', message: '请填写数量' })
          return
        }
      }

      var o = {
        list: this.tableData,
        index: this.data.index
      }
      console.log(o, 'saved')
      this.$emit('saved', o)
      this.close()
    },
    closeDialog() {
      this.data = {}
      this.tableData = []
      this.selectGoods = []
      this.close()
    }
  }
}
</script>
